/**
 * Created by macuser on 9/9/16.
 */

import Backbone from "backbone";
import _ from "underscore";
import Field from "core/models/Field";
import ModelUtils from "@HBKEngineering/model-util";
import $ from "jquery";
import async from "async";
import urlService from "../UrlService";
export default Backbone.Collection.extend(
  {
    model: Field,

    comparator: "position",

    constructor: function (models, options) {
      Backbone.Collection.apply(this, arguments);

      this._removed = [];

      if (!this.options.dataType) {
        throw new Error("dataType option not set for FieldCollection.");
      }

      this.on(
        "add",
        function (field, self, index) {
          if (!_.isNumber(index)) {
            index = self.indexOf(field);
          }

          field.set({
            position: index,
          });
        },
        this
      );

      this.on(
        "remove",
        function (field) {
          this._removed.push(field);
        },
        this
      );
    },

    /**
     * Initializes this collection.
     * @param  {Array} models  Initial models for the collection.
     * @param  {object} options The options mapping.
     * @param {app/utils/UrlBuilder} options.urlBuilder The URL builder with which to construct the path.
     * @param {app/models/Layer} options.dataType The data type with which to associate each field in the collection.
     */
    initialize: function (models, options) {
      this.options = _.defaults({}, options);
    },

    url: function () {
      return urlService.apiurl(
        "/fields/bylayer/" + ModelUtils.idFor(this.options.dataType)
      );
    },

    /**
     * Saves all records and destroys any that were removed. Returns a promise.
     */
    save: function () {
      var self = this;
      var promise = $.when();

      _.each(
        this.models,
        function (model) {
          model.set(
            "fieldSet",
            ModelUtils.idFor(this.options.dataType.get("fieldSet"))
          );
          var _values = model.get("values");
          _.each(_values, function (_value) {
            if (_value.rules != undefined && _value.rules.length > 0) {
              var _rules = [];
              _.each(_value.rules, function (_rule) {
                var _newId = self.models.find(function (_field) {
                  if (_field._originalAttributes.name == _rule) {
                    return true;
                  }
                });
                if (_newId != undefined) {
                  _rules.push(_newId.attributes.name);
                }
              });
              _value.rules = _rules;
            }
          });
          promise = $.when(promise, model.save());
        },
        this
      );

      _.each(
        this._removed,
        function (model) {
          if (!model.collection || model.collection === this) {
            //this check makes sure to preserve the field if it was just moved to a different layer
            if (!_.isString(model.url)) {
              model.url = this.url() + "/" + model.id;
            }

            promise = $.when(promise, model.destroy());
          }
        },
        this
      );

      promise.done(function () {
        self._removed = [];
      });

      return promise;
    },
  },
  {
    /**
     * Given an array of layers, determine those fields which are uniquely-named across all of them.
     * @param {Array} layers An array of `MapLayerBase` from which to draw fields.
     * @param {Boolean} [onlyShared] True to filter out any fields which are _not_ shared across all layers.
     * @return {Array} An array of `Field` instances which provide getting and setting capability to all applicable models. Note that these fields are _not_ the same fields returned by any call to `MapLayerBase.getFields`
     */
    getFields: function (layers, onlyShared) {
      var result = [];
      //get an array of all the fields in every layer
      var allFields = _.flatten(_.pluck(layers, "fields"));
      //group fields by their name
      var groupedFields = _.groupBy(allFields, function (field) {
        return field.attributes.label;
      });

      var keptFields = {};

      if (onlyShared) {
        var layerCount = _.size(layers);

        //filter out those fields which are not present on all layers
        _.each(groupedFields, function (fields, key) {
          if (fields.length == layerCount) {
            keptFields[key] = fields;
          }
        });
      } else {
        keptFields = groupedFields;
      }

      //for each field, create a decorated field where the getter tries to get a value using each of the fields with the same label
      //and where the setter sets the value on all of the fields with the same label
      _.each(keptFields, function (subFields) {
        var fieldTemplate = _.first(subFields);

        // Calling decorate on the field template uses the originalAttributes of the field. If the field has been updated in the most recent session, we want to use the updated attributes.

        result.push(
          fieldTemplate.decorate(_.defaults({}, fieldTemplate.attributes), {
            getter: function (model) {
              var value;
              for (var i = 0; i < subFields.length; i++) {
                value = subFields[i].getValue(model);

                if (value) {
                  if (
                    fieldTemplate.attributes.type == "select" ||
                    fieldTemplate.attributes.type == "radio"
                  ) {
                    var valueByLabel = _.find(
                      subFields[i].attributes.values,
                      function (val) {
                        return (
                          _.isObject(val) &&
                          (val.value == value || val.text == value)
                        );
                      }
                    );

                    if (valueByLabel) {
                      var destinationValue = _.find(
                        fieldTemplate.attributes.values,
                        function (value) {
                          return (
                            _.isObject(value) && valueByLabel.text == value.text
                          );
                        }
                      );

                      if (destinationValue) {
                        value = destinationValue.value;
                      }
                    }
                  }

                  return value;
                }
              }
            },

            setter: function (model, value) {
              _.each(subFields, function (subField) {
                var finalValue = value;

                if (
                  value &&
                  (fieldTemplate.attributes.type == "select" ||
                    fieldTemplate.attributes.type == "radio")
                ) {
                  var valueByLabel = _.find(
                    fieldTemplate.attributes.values,
                    function (val) {
                      return (
                        _.isObject(val) &&
                        (val.value == value || val.text == value)
                      );
                    }
                  );

                  if (valueByLabel) {
                    var destinationValue = _.find(
                      subField.attributes.values,
                      function (value) {
                        return (
                          _.isObject(value) && valueByLabel.text == value.text
                        );
                      }
                    );

                    if (destinationValue) {
                      finalValue = destinationValue.value;
                    }
                  }
                }

                subField.setValue(model, finalValue);
              });
            },
          })
        );
      });

      return result;
    },
  }
);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/FieldCollection.js
// module id = 352
// module chunks = 1